angular.module('iw.frontyard.repayment_calculator')
    .directive('iwFocusInput', function () {
        return {
            restrict: 'A',
            controller: function ($scope) {
                $scope.changeFocus = function (event) {
                    angular.element(event.target).children(0).focus();
                };
            }
        };
    });
